import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { updateAppState } from '../../../../actions/appstate';
import { Box, FormControl, Select, MenuItem } from '@mui/material'
import moment from "moment";
import { analytics } from '../../../../hooks/use-analytics';
import { getPermissions } from '../../../../app/util';

function ToggleRoomTypeRestrictions() {
    const { workspace_controls } = useSelector(state => state.app.current_state.app_state);
    const dispatch = useDispatch();
    const state = useSelector(state => state);
    const { auth, app } = state;
    const { profile, user } = auth;
    let { current_state } = app;
    let { app_state, ui_state } = current_state
    const { permissions, index } = getPermissions(profile.property_details, app_state.property_id);

    const handleChange = (value) => {
        workspace_controls.isRestrictionsRoomType = value;
        let date_range_type = "scopeTypeChanged_Date";
        // if (workspace_controls.isRestrictionsRoomType === true) {
        //      date_range_type = "restrictionsRoomType";
        // }
        if (value === true && value !== "product") {
            analytics.track("restriction_rt_data_level", {});
        }else if (value === true && value === "product") {
            analytics.track("restriction_product_data_level", {});
        } else {
            analytics.track("restriction_hotel_data_level", {});
        }
        dispatch(updateAppState("toggleRoomTypeRestrictions", {
            app_state: {
                workspace_controls: { ...workspace_controls },
                date_range_type,
            },
            ui_state: { showspinner: true }
        }));
    }

    return (
        <>
            <Box id="tabletype" sx={{ position: "relative", paddingLeft: 0, backgroundColor: 'blue', height: 1 / 2 }}>
                <Box className="data-level-label">Data Level </Box>
                <FormControl size="small" sx={{ minWidth: "100%", borderRadius: "16px" }}>
                    <Select fullWidth
                        className='tabular-data-filter'
                        value={workspace_controls.isRestrictionsRoomType}
                        onChange={(event) => handleChange(event.target.value)}
                        sx={{ height: "30px", mt: "5px" }}
                    >
                        <MenuItem value={false} className='tabular-data-filter'>Hotel</MenuItem>
                        <MenuItem value={true} className='tabular-data-filter'>Room Type</MenuItem>
                        {permissions?.di_version === 4 && permissions?.restriction_d?.restriction_product && (
                            <MenuItem value="product" className="tabular-data-filter">
                                Product
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>
            </Box>
        </>
    )
}

export default ToggleRoomTypeRestrictions;
